module.exports = __webpack_public_path__ + "static/media/logo-black-tablet.0ed98b52.svg";